import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconLock = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 20 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M17.000,24.000 L3.000,24.000 C1.346,24.000 0.000,22.655 0.000,21.000 L0.000,11.000 C0.000,9.346 1.346,8.000 3.000,8.000 L4.000,8.000 L4.000,6.000 C4.000,2.692 6.691,0.000 10.000,0.000 C13.309,0.000 16.000,2.692 16.000,6.000 L16.000,8.000 L17.000,8.000 C18.654,8.000 20.000,9.346 20.000,11.000 L20.000,21.000 C20.000,22.655 18.654,24.000 17.000,24.000 ZM10.000,2.000 C7.794,2.000 6.000,3.794 6.000,6.000 L6.000,8.000 L14.000,8.000 L14.000,6.000 C14.000,3.794 12.206,2.000 10.000,2.000 ZM18.000,11.000 C18.000,10.448 17.551,10.000 17.000,10.000 L3.000,10.000 C2.449,10.000 2.000,10.448 2.000,11.000 L2.000,21.000 C2.000,21.551 2.449,22.000 3.000,22.000 L17.000,22.000 C17.551,22.000 18.000,21.551 18.000,21.000 L18.000,11.000 ZM11.000,15.722 L11.000,18.000 C11.000,18.552 10.552,19.000 10.000,19.000 C9.448,19.000 9.000,18.552 9.000,18.000 L9.000,15.722 C8.405,15.375 8.000,14.737 8.000,14.000 C8.000,12.897 8.897,12.000 10.000,12.000 C11.103,12.000 12.000,12.897 12.000,14.000 C12.000,14.737 11.595,15.375 11.000,15.722 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconLock.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
